import type { ModuleWithProgress } from '@/lib/api/lms';

export interface FlatTopic {
  id: string;
  title: string;
  moduleId: string;
  moduleTitle: string;
}

export function flattenTopics(modules: ModuleWithProgress[] | undefined): FlatTopic[] {
  if (!modules) return [];
  const out: FlatTopic[] = [];
  const sortedMods = [...modules].sort((a, b) => a.sort_order - b.sort_order);
  for (const m of sortedMods) {
    const topics = [...m.topics].sort((a, b) => a.sort_order - b.sort_order);
    for (const t of topics) {
      out.push({ id: t.id, title: t.title, moduleId: m.id, moduleTitle: m.title });
    }
  }
  return out;
}

export function adjacentTopics(
  flat: FlatTopic[],
  topicId: string,
): { prev: FlatTopic | null; next: FlatTopic | null } {
  const i = flat.findIndex((t) => t.id === topicId);
  if (i === -1) return { prev: null, next: null };
  return {
    prev: i > 0 ? flat[i - 1] : null,
    next: i < flat.length - 1 ? flat[i + 1] : null,
  };
}

export function findCurrentModule(
  modules: ModuleWithProgress[] | undefined,
  topicId: string,
): ModuleWithProgress | null {
  if (!modules) return null;
  return modules.find((m) => m.topics.some((t) => t.id === topicId)) ?? null;
}
